import Component from "./onboarding.component";
import { Config } from "./onboarding.config";
import { watchOnboarding as saga } from "./redux/onboarding.sagas";
import { reducer } from "./redux/onboarding.reducer";

export default { Component, saga, reducer, config: Config };
